import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

const MobileCTA = () => (
  <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-background/95 backdrop-blur-sm border-t border-border p-3 flex gap-3">
    <Button asChild className="flex-1 h-12 text-base font-semibold">
      <Link to="/schedules">View Game Schedules</Link>
    </Button>
    <Button asChild variant="outline" className="h-12 px-4">
      <a href="tel:+19895517473" aria-label="Call Christopher at (989) 551-7473">
        <Phone className="h-5 w-5" />
      </a>
    </Button>
  </div>
);

export default MobileCTA;
